import { useEffect, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Button } from "../components/ui/button";
import { LoadingScreen } from "../components/ui/loading-screen";

/**
 * Cognito redirects to /login?code=...&state=... after a successful sign-in.
 * AuthContext handles the actual code exchange on mount; this page just
 * surfaces a spinner and then bounces to the post-login destination.
 */
export function LoginCallback(): ReactNode {
  const { status, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "authenticated") {
      navigate("/", { replace: true });
    }
    if (status === "anonymous") {
      navigate("/welcome", { replace: true });
    }
  }, [status, navigate]);

  if (status === "error") {
    return (
      <div className="grid min-h-screen place-items-center px-5">
        <div className="max-w-md text-center">
          <h1 className="text-headline-lg">Sign-in failed</h1>
          <p className="mt-4 text-body-md text-on-surface-variant">
            {error ?? "Something went wrong while signing in."}
          </p>
          <Button
            className="mt-6"
            onClick={() => navigate("/welcome", { replace: true })}
          >
            Try signing in again
          </Button>
        </div>
      </div>
    );
  }
  return <LoadingScreen message="Finishing your sign-in…" />;
}
